// @flow
import * as React from 'react';

type Render<T> = (props: T) => React.Element<*>;

type Props<T> = {
    render: Render<T>
};

const errorMessage = `👾 Missing render prop when using ~/mappings/container 👾

You're probably using \`mergeProps\` in a \`connect\` function without passing on \`ownProps\`.
Please make sure that \`render\` is passed from \`ownProps\` during \`mergeProps\` for example:

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps // or
        render: ownProps.render
    }
}
`;

export default class extends React.Component<Props<*>, void> {
    validRender(render: Render<*>) {
        return render && typeof render === 'function';
    }

    checkProps(render: Render<*>) {
        if (!this.validRender(render)) {
            throw new Error(errorMessage);
        }
    }

    componentDidMount() {
        this.checkProps(this.props.render);
    }

    componentWillReceiveProps(nextProps: Props<*>) {
        this.checkProps(nextProps.render);
    }

    render() {
        const { render, ...rest } = this.props;
        return this.validRender(render) ? render(rest) : null;
    }
}



// WEBPACK FOOTER //
// ./src/core/domains/container.js